export default __webpack_public_path__ + "static/media/main_slide_Image5.52028918.jpg";